import { autoload } from './internal/autoload';
import { registerInitializer } from './public/initializerRegistry';
import { load, loadAndRender } from './public/loader';

export { registerInitializer, loadAndRender, load };
export { ENV, EVENT_TYPE, PAGE_TYPE, PROTOCOL } from './types';

// Only auto-execute in browser environment
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', autoload);
    } else {
        autoload();
    }
}
